import type { Country } from '../../types';

type CountryColumnHeadersProps = {
  browseMode: boolean;
  visibleCountries: Country[];
  selectedCountry: string;
  COUNTRIES: Country[];
};

export function CountryColumnHeaders({
  browseMode,
  visibleCountries,
  selectedCountry,
  COUNTRIES,
}: CountryColumnHeadersProps) {
  const isCompact = visibleCountries.length >= 14;
  const colClass = isCompact ? 'w-[45px]' : 'w-[60px]';

  const cellInner = (flag: string | undefined, code: string) =>
    isCompact ? (
      <span className="text-xs select-none whitespace-nowrap transform -rotate-45 origin-center">
        {code}
      </span>
    ) : (
      <div className="flex flex-col items-center justify-center h-full gap-1">
        <span className="text-sm select-none">{flag}</span>
        <span className="text-xs select-none whitespace-nowrap">{code}</span>
      </div>
    );

  if (browseMode) {
    return (
      <>
        {visibleCountries.map(c => (
          <th
            key={c.code}
            className={`text-center px-1 py-2 font-medium text-foreground bg-transparent cursor-default select-none ${colClass}`}
            title={c.name}
          >
            <div className="flex flex-col items-center justify-center h-full">{cellInner(c.flag, c.code)}</div>
          </th>
        ))}
      </>
    );
  }

  if (!selectedCountry) return null;
  const info = COUNTRIES.find(c => c.code === selectedCountry);
  return (
    <th
      className={`text-center px-1 py-2 font-medium text-foreground bg-transparent cursor-default select-none ${colClass}`}
      title={info?.name}
    >
      <div className="flex flex-col items-center justify-center h-full">
        {cellInner(info?.flag, selectedCountry)}
      </div>
    </th>
  );
}
